import React from 'react'

interface Props {}

const LandingPageStandardRequestInfo: React.FunctionComponent<Props> = () => {
  return <>LandingPageStandardRequestInfo</>
}

export default LandingPageStandardRequestInfo
